import { EMPTY_OBJECT } from '../../../../constants/common'
import { ARCHIVED_FILTER_NAME } from '../../../../constants/filter'
import { SEARCH_RESULTS_QUERY_PARAM_KEY } from '../../../../constants/route'
import { getSearchResultsListApiParams } from '../../SearchResults.utils'
import { useSearchResultsParams } from '../useSearchResultsParams'

export function useSearchResultsTableOptions({
  asyncTableOptions = EMPTY_OBJECT,
}) {
  const { isArchived, searchQuery } = useSearchResultsParams()

  return {
    asyncTableOptions: {
      ...asyncTableOptions,
      extraFilters: {
        [ARCHIVED_FILTER_NAME]: isArchived,
        [SEARCH_RESULTS_QUERY_PARAM_KEY]: searchQuery,
      },
      getListApiParams: getSearchResultsListApiParams,
      isLocalFilterState: true,
      withoutSubMenu: true,
    },
    extraSelectionResetDeps: [isArchived, searchQuery],
    isArchived,
    searchQuery,
  }
}
